import { useMemo } from 'react';

import { TelemetryContentPlace, TelemetryContentType } from '../../Player';
import { useStreamHandler } from '../../feature-player/hooks/config/use-stream-handler';

import { usePromoPlayerConfigHandler } from './use-promo-player-config-handler';

interface Props {
    telemetryContentPlace: TelemetryContentPlace;
    telemetryContentType: TelemetryContentType;
}

export const usePromoStreamHandler = ({ telemetryContentPlace, telemetryContentType }: Props) => {
    const promoPlayerConfigHandler = usePromoPlayerConfigHandler(
        useMemo(
            () => ({ telemetryContentPlace, telemetryContentType }),
            [telemetryContentPlace, telemetryContentType]
        )
    );

    const handlers = useMemo(() => [promoPlayerConfigHandler], [promoPlayerConfigHandler]);
    return useStreamHandler(handlers);
};
